/** openapi.yaml components.schemas.Gender */
export const GENDERS = ['Male', 'Female'] as const;
export type Gender = (typeof GENDERS)[number];

/** D1 — verbatim 8 values, flat set, no enforced transition graph (05-architecture.md §2.3). */
export const STUDENT_STATUSES = [
  'ناجح',
  'راسب',
  'منقول',
  'راسب سنتين',
  'خدمات',
  'منازل',
  'استثناء',
  'أزهر',
] as const;
export type StudentStatus = (typeof STUDENT_STATUSES)[number];

/** New Student Affairs document-TRANSFER status (§21). Flat pick-list, no enforced transition
 * graph, distinct from the academic STUDENT_STATUSES. */
export const TRANSFER_STATUSES = [
  'ملف مكتمل',
  'طلب تحويل مختوم مدرسة',
  'طلب تحويل مختوم إدارة',
  'طلب تحويل مختوم إدارة ومديرية (مكتمل)',
] as const;
export type TransferStatus = (typeof TRANSFER_STATUSES)[number];

/** openapi.yaml components.schemas.GuardianRelationship */
export const GUARDIAN_RELATIONSHIPS = ['Father', 'Mother', 'Guardian', 'Other'] as const;
export type GuardianRelationship = (typeof GUARDIAN_RELATIONSHIPS)[number];

/** openapi.yaml components.schemas.ApplicationSource */
export const APPLICATION_SOURCES = [
  'Direct',
  'Sales Conversion',
  'Walk-in',
  'Online',
  'Other',
] as const;
export type ApplicationSource = (typeof APPLICATION_SOURCES)[number];
